const ufeApi = require('services/api/ufeApi');
const { userXTimestampHeader } = require('utils/Headers');
const locationUtils = require('utils/Location');

function gameOptIn(token, { gameId, loyaltyId }) {
    const sdnApiHost = Sephora.configurationSettings.sdnApiHost;
    const params = locationUtils.isPreviewEnvironment() ? '?isPreview=true' : '';
    const url = `${sdnApiHost}/v1/game/${gameId}/user/${loyaltyId}/opt-in${params}`;
    const timeStamp = userXTimestampHeader()['x-timestamp'];

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: {
                'x-source': 'rwd',
                'X-Request-Timestamp': timeStamp,
                authorization: `Bearer ${token}`
            }
        })
        .then(data => data);
}

module.exports = { gameOptIn };
